import * as S from './styled';

import FilterFormatterMixin from '@/components/Dashboard/common/UaFilterSettingPanel/mixin';

import { FilterGroup } from './FilterGroup';
import { FilterItem } from './FilterItem';

import { isGroup } from './utils';

export default {
    name: 'FilterInfo',
    mixins: [FilterFormatterMixin],
    props: {
        groupFilters: {
            type: Array,
            required: true,
        },
    },
    render() {
        const { groupFilters } = this;

        return (
            <S.Wrapper>
                {groupFilters.map(({ groupId, where }) => (
                    <S.GroupSet key={groupId}>
                        <S.GroupIdLabel>
                            {this.groupTranslator(groupId)}
                        </S.GroupIdLabel>
                        {where.map((condition, idx) => {
                            const isGroupCondition = isGroup(condition);

                            return isGroupCondition ? (
                                <FilterGroup
                                    key={`${groupId}-${idx}`}
                                    condition={condition}
                                    depth={0}
                                    groupId={groupId}
                                />
                            ) : (
                                <FilterItem
                                    key={`${groupId}-${idx}`}
                                    condition={condition}
                                    groupId={groupId}
                                />
                            );
                        })}
                    </S.GroupSet>
                ))}
            </S.Wrapper>
        );
    },
};
